export default __webpack_public_path__ + "static/blob9-0315d76b1d11f8a2ee881fbd05883d6a.svg";